module.exports = __webpack_public_path__ + "img/call__contact.549ce23f.jpg";